const PageHeader = () => {
  return (
    <div className="container-fluid page-header py-5">
      <div className="container py-5">
        <h1 className="display-3 text-white mb-3 animated slideInDown">
          <br />
          <br />
        </h1>
      </div>
    </div>
  );
};
export default PageHeader;
